import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

/**
 * Screen-context retrieval choice per chat, keyed by thread ID, or by the
 * composer draft ID before New Chat's first send. A missing key defers to the
 * user's chat setting. Kept apart from `chatStore` so `sdk-init` can read it
 * without an import cycle
 */
class ScreenContextSearchStore {
  disabledByChat: Record<string, boolean> = {};

  constructor() {
    makeAutoObservable(this);
    void makePersistable(this, {
      name: 'screenContextSearchStore',
      properties: ['disabledByChat'],
      storage: window.localStorage,
    });
  }

  set(chatKey: string, disabled: boolean) {
    this.disabledByChat = { ...this.disabledByChat, [chatKey]: disabled };
  }

  move(fromKey: string, toKey: string) {
    const { [fromKey]: disabled, ...rest } = this.disabledByChat;
    if (disabled === undefined) return;
    this.disabledByChat = { ...rest, [toKey]: disabled };
  }
}

export const screenContextSearchStore = new ScreenContextSearchStore();
